export class OfferLetterClause {
  id?: number;
  version?: number;

  orgId: number;
  employeeClassId: number;
  employeeClassName?: string;
  order: number;
  type: string;
  text: string;
}